import { styled } from '@mui/material'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .highcharts-credits,
  .highcharts-legend-item {
    display: none !important;
  }

  &.highlightLabel.highcharts-data-label text {
    font-weight: bold !important;
  }

  &.simpleLabel.highcharts-data-label text {
    font-weight: normal !important;
  }
  
`

export const Root = styled('div')`
  width: 100%;
`
